export const DUAL_ZIP_CODE_MESSAGE =
  'Hi Sakaralite! Currently we can only process orders that have the same delivery zip code. If you would like to place an order for two programs being sent to different addresses, they must be placed as separate orders.'
export const ALL_MEALS = ['breakfast', 'lunch', 'dinner']

export const PurchaseTypes = {
  SUBSCRIPTION: 'sub',
  PACK_OF_WEEKS: 'pack',
} as const
export type PurchaseType = (typeof PurchaseTypes)[keyof typeof PurchaseTypes]
